import { AUTOMATION_NAMESPACE_INJECTION_TOKEN$, AUTOMATION_PARTNER_ID_INJECTION_TOKEN$ } from '@galaxy/automata/shared';
import { AutomationReplacementChipsDataService, PagedResponse } from '../common/components';
import { Inject, Injectable } from '@angular/core';
import { combineLatest, map, Observable, of, take } from 'rxjs';
import { IAMService } from '@vendasta/iam';
import { switchMap } from 'rxjs/operators';
import { getFormattedDisplayName } from './users.service';
import { VbcApiService, VbcUser } from '@galaxy/vbc';

@Injectable({ providedIn: 'root' })
export class SmbUsersSelectorService implements AutomationReplacementChipsDataService<VbcUser> {
  supportsSearching = false;

  constructor(
    private readonly vbcApiService: VbcApiService,
    private readonly iamService: IAMService,
    // Namespace is agid. PartnerId is pid. This only works inside an SMB context (a.k.a. business app)
    @Inject(AUTOMATION_NAMESPACE_INJECTION_TOKEN$) public readonly namespace$: Observable<string>,
    @Inject(AUTOMATION_PARTNER_ID_INJECTION_TOKEN$) public readonly partnerId$: Observable<string>,
  ) {}

  doLookup(): Observable<PagedResponse<VbcUser>> {
    return combineLatest([this.namespace$, this.partnerId$]).pipe(
      take(1),
      switchMap(([agid, pid]) => this.vbcApiService.getUsersOnAccountGroup(pid, agid)),
      map((resp) => {
        return {
          results: resp || [],
          hasMore: false,
          nextCursor: '',
        };
      }),
    );
  }

  convertDataToDisplay(s: VbcUser): Observable<string> {
    return of(getFormattedDisplayName(s) || '');
  }

  convertDataToFormValue(x: VbcUser): any {
    return x.unifiedUserId;
  }

  getMulti(x: string[]): Observable<VbcUser[]> {
    return combineLatest([this.namespace$, this.partnerId$]).pipe(
      take(1),
      switchMap(([agid, pid]) => this.vbcApiService.getUsersOnAccountGroup(pid, agid)),
      map((resp) => {
        return (resp || []).filter((u) => x.includes(u.unifiedUserId));
      }),
    );
  }
}
